import React, { useMemo } from "react";

import Wrapper from "components/commons/wrapper/Wrapper";

import { OrganizationInvoicing } from "./OrganizationInvoicing";
import { PersonalInvoicing } from "./PersonalInvoicing";
import { AccountType } from "core/auth/auth.entity";
import { useAppSelector } from "utils/store";

function Invoicing() {
  const myPanel = useAppSelector((state) => state.auth.myPanel);
  const authComponent = useMemo(() => {
    switch (myPanel.type) {
      case AccountType.Personal:
        return <PersonalInvoicing />;
      case AccountType.Organization:
        return <OrganizationInvoicing />;
      default:
        return <PersonalInvoicing />;
    }
  }, [myPanel.type]);

  return (
    <>
      <Wrapper>{authComponent}</Wrapper>
    </>
  );
}

export default Invoicing;
